import VideoUploaderByFilePath from 'components/VideoUploader/VideoUploaderByFilePath';
import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { IVideosContext, VideosContext } from '../../../videosState/videosContext';
import Text from 'components/Text/Text';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import { createAppError } from 'utils/helpers';
import { downloadBlob } from 'backend/additionalInformation';
import classNames from 'classnames';
import style from './PreviewModal.module.scss';

interface IPreviewModal {
	isVisible: boolean;
	IDForFullInfo: Nullable<string>;
	onClose: () => void;
}

const PreviewModal: React.FC<IPreviewModal> = ({ isVisible, IDForFullInfo, onClose }) => {
	const { showLoader, hideLoader, addAppError } = useContext<IAppContext>(AppContext);
	const { videos } = useContext<IVideosContext>(VideosContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const videoData = videos.videos.find((el) => el.id === IDForFullInfo);

	const handleDownload = async () => {
		if (videoData?.videoPath) {
			showLoader();
			try {
				const file = await downloadBlob(videoData.videoPath);
				const href = URL.createObjectURL(file.data);

				const link = document.createElement('a');
				link.href = href;
				link.download = 'video.mp4';
				document.body.appendChild(link);
				link.click();

				document.body.removeChild(link);
				URL.revokeObjectURL(href);
				hideLoader();
			} catch (err) {
				hideLoader();
				const error = err as Error;
				const appError = createAppError(error);
				addAppError(appError);
			}
		}
	};

	return (
		<div className={containerClasses} data-test="PreviewModal">
			<div className={style.wrapper}>
				<div className={style.closeIconWrapper} onClick={onClose}>
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				</div>
				<div className={style.content}>
					{IDForFullInfo && (
						// <VideoUploaderByEntityId
						// 	loaderSize="big"
						// 	isShowControls={true}
						// 	resource="Videos"
						// 	entityID={videoData?.videoPath || ''} // TODO replace videoPath with something for the new BE
						// />
						<VideoUploaderByFilePath
							filePath={videoData?.videoPath || ''}
							loaderSize="big"
							isShowControls={true}
						/>
					)}
				</div>
				<div className={style.buttonWrapper}>
					<Button
						onClick={handleDownload}
						icon={
							<svg className={style.downloadIcon}>
								<use xlinkHref={`${breadcrumbs}#downloadArrow`} />
							</svg>
						}>
						<Text translationNameSpace="listing" translationKey="downloadVideoButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default React.memo(PreviewModal);
